export default function transformer(payload) {
  if ((!!payload.rayon || payload.rayon === 0)
  && (!!payload.latitude || payload.latitude === 0)
  && (!!payload.longitude || payload.longitude === 0)) {
    payload.coordonnees =  {
      latitude: payload.latitude,
      longitude: payload.longitude,
      rayon: payload.rayon,
    };
  }
  if (payload.archive === null) payload.archive = null;
  else payload.archive = typeof payload.archive === 'boolean' ? payload.archive : false;
  payload.sousType = payload.sousType ? [payload.sousType] : [];
  payload.typologie = payload.typologie ? [payload.typologie] : [];
  delete payload.latitude;
  delete payload.longitude;
  delete payload.rayon;
  return {
    skipCount: payload.skip || 0,
    maxResultCount: payload.maxResult || 9999999,
    query: payload,
  };
}